var _g, _defs;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgContribution(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 64,
    height: 65,
    viewBox: "0 0 64 65",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Dark-Pink-24"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Color",
    d: "M27.9096 28.1455C30.4273 26.764 33.5727 26.764 36.0904 28.1455L54.7134 38.3645C56.4289 39.3058 56.4289 41.5796 54.7134 42.5209L36.0904 52.7399C33.5727 54.1214 30.4273 54.1214 27.9096 52.7399L9.28662 42.5209C7.57113 41.5796 7.57112 39.3058 9.28662 38.3645L27.9096 28.1455Z",
    fill: "url(#paint0_linear_478_4198)"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Glass",
    filter: "url(#filter0_bi_478_4198)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M27.9096 20.1455C30.4273 18.764 33.5727 18.764 36.0904 20.1455L54.7134 30.3645C56.4289 31.3058 56.4289 33.5796 54.7134 34.5209L36.0904 44.7399C33.5727 46.1214 30.4273 46.1214 27.9096 44.7399L9.28662 34.5209C7.57113 33.5796 7.57112 31.3058 9.28662 30.3645L27.9096 20.1455Z",
    fill: "#1D1D1D",
    fillOpacity: 0.05
  }), /*#__PURE__*/React.createElement("path", {
    d: "M27.9096 20.1455C30.4273 18.764 33.5727 18.764 36.0904 20.1455L54.7134 30.3645C56.4289 31.3058 56.4289 33.5796 54.7134 34.5209L36.0904 44.7399C33.5727 46.1214 30.4273 46.1214 27.9096 44.7399L9.28662 34.5209C7.57113 33.5796 7.57112 31.3058 9.28662 30.3645L27.9096 20.1455Z",
    fill: "url(#paint1_linear_478_4198)",
    fillOpacity: 0.2
  }), /*#__PURE__*/React.createElement("path", {
    d: "M28.0379 20.3793C30.4757 19.0416 33.5243 19.0416 35.9621 20.3793L54.5851 30.5983C56.1161 31.4384 56.1161 33.4471 54.5851 34.2872L35.9621 44.5061C33.5243 45.8438 30.4757 45.8438 28.0379 44.5061L9.41491 34.2872C7.88392 33.4471 7.88392 31.4384 9.4149 30.5983L28.0379 20.3793Z",
    stroke: "url(#paint2_linear_478_4198)",
    strokeOpacity: 0.1,
    strokeWidth: 0.533333
  })), /*#__PURE__*/React.createElement("g", {
    id: "Glass_2",
    filter: "url(#filter1_bi_478_4198)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M27.9096 12.1455C30.4273 10.764 33.5727 10.764 36.0904 12.1455L54.7134 22.3645C56.4289 23.3058 56.4289 25.5796 54.7134 26.5209L36.0904 36.7399C33.5727 38.1214 30.4273 38.1214 27.9096 36.7399L9.28662 26.5209C7.57113 25.5796 7.57112 23.3058 9.28662 22.3645L27.9096 12.1455Z",
    fill: "#1D1D1D",
    fillOpacity: 0.05
  }), /*#__PURE__*/React.createElement("path", {
    d: "M27.9096 12.1455C30.4273 10.764 33.5727 10.764 36.0904 12.1455L54.7134 22.3645C56.4289 23.3058 56.4289 25.5796 54.7134 26.5209L36.0904 36.7399C33.5727 38.1214 30.4273 38.1214 27.9096 36.7399L9.28662 26.5209C7.57113 25.5796 7.57112 23.3058 9.28662 22.3645L27.9096 12.1455Z",
    fill: "url(#paint3_linear_478_4198)",
    fillOpacity: 0.2
  }), /*#__PURE__*/React.createElement("path", {
    d: "M28.0379 12.3793C30.4757 11.0416 33.5243 11.0416 35.9621 12.3793L54.5851 22.5983C56.1161 23.4384 56.1161 25.4471 54.5851 26.2872L35.9621 36.5061C33.5243 37.8438 30.4757 37.8438 28.0379 36.5061L9.41491 26.2872C7.88392 25.4471 7.88392 23.4384 9.4149 22.5983L28.0379 12.3793Z",
    stroke: "url(#paint4_linear_478_4198)",
    strokeOpacity: 0.1,
    strokeWidth: 0.533333
  })))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_bi_478_4198",
    x: 5,
    y: 16.1094,
    width: 54,
    height: 32.6665,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    in: "BackgroundImageFix",
    stdDeviation: 1.5
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "SourceAlpha",
    operator: "in",
    result: "effect1_backgroundBlur_478_4198"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_backgroundBlur_478_4198",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 0.5
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 1
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "arithmetic",
    k2: -1,
    k3: 1
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 1 0 0 0 0 1 0 0 0 0 1 0 0 0 0.15 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "shape",
    result: "effect2_innerShadow_478_4198"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter1_bi_478_4198",
    x: 5,
    y: 8.10938,
    width: 54,
    height: 32.6665,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    in: "BackgroundImageFix",
    stdDeviation: 1.5
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "SourceAlpha",
    operator: "in",
    result: "effect1_backgroundBlur_478_4198"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_backgroundBlur_478_4198",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 0.5
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 1
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "arithmetic",
    k2: -1,
    k3: 1
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 1 0 0 0 0 1 0 0 0 0 1 0 0 0 0.15 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "shape",
    result: "effect2_innerShadow_478_4198"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_478_4198",
    x1: 10,
    y1: 32.4427,
    x2: 60.1961,
    y2: 44.9917,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FE82DB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#68E4FF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_478_4198",
    x1: 10,
    y1: 24.4427,
    x2: 60.1961,
    y2: 36.9917,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FE82DB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#68E4FF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_478_4198",
    x1: 9.5,
    y1: 20.3215,
    x2: 56,
    y2: 20.3215,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FD84DC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#7FD6FA"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint3_linear_478_4198",
    x1: 10,
    y1: 16.4427,
    x2: 60.1961,
    y2: 28.9917,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FE82DB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#68E4FF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint4_linear_478_4198",
    x1: 9.5,
    y1: 12.3215,
    x2: 56,
    y2: 12.3215,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FD84DC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#7FD6FA"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgContribution);
export default __webpack_public_path__ + "static/media/contribution.d3b1e0bb283f9b3a7e236abbadf99573.svg";
export { ForwardRef as ReactComponent };